import React from "react";
import { Grid } from "@sumprio/ui";
import { LineChartSqaureIcon } from "@sumprio/ui/icons";
import EmptyState from "../EmptyState";
import { ActivityFeedItem } from "./ActivityFeedItem";
import type { FeedItem, ActivityFeedPanelProps } from "./types";

const DEFAULT_EMPTY_TITLE = "No activity yet";
const DEFAULT_EMPTY_DESCRIPTION = "Activity and timeline will appear here.";
const DEFAULT_MIN_HEIGHT = 240;

export function ActivityFeedPanel({
  items,
  emptyTitle = DEFAULT_EMPTY_TITLE,
  emptyDescription = DEFAULT_EMPTY_DESCRIPTION,
  emptyIcon,
  minHeight = DEFAULT_MIN_HEIGHT,
}: ActivityFeedPanelProps) {
  const hasItems = Array.isArray(items) && items.length > 0;
  const icon = emptyIcon ?? <LineChartSqaureIcon size="xl" />;

  return (
    <Grid
      display="flex"
      flexDirection="column"
      gap="md"
      flex={1}
      width="100%"
      style={{ minHeight: 0, height: "100%" }}
    >
      {!hasItems ? (
        <Grid
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          flex={1}
          style={{ minHeight }}
        >
          <EmptyState icon={icon} title={emptyTitle} description={emptyDescription} />
        </Grid>
      ) : (
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            width: "100%",
          }}
        >
          <Grid display="flex" flexDirection="column" gap="md" width="100%">
            {items.map((item: FeedItem) => (
              <ActivityFeedItem
                key={item.id ?? item.timestamp ?? Math.random()}
                name={item.name}
                initials={item.initials}
                message={item.message}
                timestamp={item.timestamp}
                avatarSize="sm"
              />
            ))}
          </Grid>
        </div>
      )}
    </Grid>
  );
}
